"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcastPodcast1Schema = void 0;
exports.AcastPodcast1Schema = {
    "$id": "https://www.redbull.com/schemas/content/ext/services/acast-audio/1.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "AcastPodcast1",
    "description": "Add a Acast embed",
    "type": "object",
    "properties": {
        "type": {
            "type": "string",
            "enum": [
                "rrn:content:ext:services:acast-audio:1"
            ]
        },
        "attributes": {
            "type": "object",
            "properties": {
                "url": {
                    "type": "string",
                    "description": "Acast embed URL (https://embed.acast.com/redbulletin/thereboundqueen)",
                    "pattern": "^https://embed.acast.com/.*"
                }
            },
            "required": [
                "url"
            ]
        }
    },
    "required": [
        "type",
        "attributes"
    ]
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiMS5zY2hlbWEuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi8uLi9zcmMvbW9kdWxlcy9jb250ZW50L2V4dC9zZXJ2aWNlcy9hY2FzdC1hdWRpby8xLnNjaGVtYS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBYSxRQUFBLG1CQUFtQixHQUFHO0lBQ2pDLEtBQUssRUFBRSxnRkFBZ0Y7SUFDdkYsU0FBUyxFQUFFLDhDQUE4QztJQUN6RCxPQUFPLEVBQUUsZUFBZTtJQUN4QixhQUFhLEVBQUUsbUJBQW1CO0lBQ2xDLE1BQU0sRUFBRSxRQUFRO0lBQ2hCLFlBQVksRUFBRTtRQUNaLE1BQU0sRUFBRTtZQUNOLE1BQU0sRUFBRSxRQUFRO1lBQ2hCLE1BQU0sRUFBRTtnQkFDTix3Q0FBd0M7YUFDekM7U0FDRjtRQUNELFlBQVksRUFBRTtZQUNaLE1BQU0sRUFBRSxRQUFRO1lBQ2hCLFlBQVksRUFBRTtnQkFDWixLQUFLLEVBQUU7b0JBQ0wsTUFBTSxFQUFFLFFBQVE7b0JBQ2hCLGFBQWEsRUFBRSx1RUFBdUU7b0JBQ3RGLFNBQVMsRUFBRSw2QkFBNkI7aUJBQ3pDO2FBQ0Y7WUFDRCxVQUFVLEVBQUU7Z0JBQ1YsS0FBSzthQUNOO1NBQ0Y7S0FDRjtJQUNELFVBQVUsRUFBRTtRQUNWLE1BQU07UUFDTixZQUFZO0tBQ2I7Q0FDRixDQUFBIn0=